<template>
  <div class="order-export">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            {{ $t('OrderFoodExportReport.Title') }}
          </div>
          <div class="tip">
            {{ $t('OrderFoodExportReport.Tip') }}
          </div>
        </div>
        <div class="right">
        </div>
      </div>
      <FilterFrame
        ref="filter"
        :filter-form="filterForm"
        submit-type="export"
        @search="handleExport"
      />

      <div v-show="reportDataList.length > 0">
        <div class="order-export__table-title">
          <div class="title_bar">
            <div class="left">
              <div class="title">
                {{ $t('OrderFoodExportReport.TableTitle') }}
              </div>
              <div class="tip">
                {{ $t('OrderFoodExportReport.TableTip') }}
              </div>
            </div>
            <div class="right">
              <el-button round icon="el-icon-refresh" @click="handleRefreshTable(true)">
                {{ $t('OrderFoodExportReport.RefreshTable') }}
              </el-button>
            </div>
          </div>
        </div>
        <el-table :data="reportDataList">
          <el-table-column label="#" type="index" width="50" prop="index">
          </el-table-column>
          <el-table-column :label="$t('OrderFoodExportReport.Filename')" prop="fileName">
          </el-table-column>
          <el-table-column :label="$t('OrderFoodExportReport.State')" width="120" prop="displayState" align="center">
          </el-table-column>
          <el-table-column :label="$t('OrderFoodExportReport.FilterConditions')" width="150" prop="displayPriceType" align="center">
          </el-table-column>
          <el-table-column :label="$t('OrderFoodExportReport.FileCompletedDate')" width="180" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.state <= 3" class="order-export__completed-content">
                <el-tooltip class="item" effect="light" placement="top">
                  <i class="el-icon-warning-outline"></i>
                  <div slot="content" class="order-export__completed-tooltip">
                    <span class="order-export__completed-tooltip-title">{{ $t('OrderFoodExportReport.EstimatedCompletionTime') }}</span>
                    <span>{{ scope.row.estimatedCompletionAt }}</span>
                  </div>
                </el-tooltip>
              </div>
              <div v-else-if="scope.row.state === 4">
                {{ scope.row.updatedAt }}
              </div>
              <div v-else-if="scope.row.state === 5">
                <span>-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('OrderFoodExportReport.FileValidDate')" width="180" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.state === 4">{{ scope.row.validDate }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('OrderFoodExportReport.Action')" width="150" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                :disabled="scope.row.state !== 4"
                @click="handleClickDownload(scope.row)"
              >
                {{ $t('OrderFoodExportReport.download') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <TableLoading :is-loading="loading" />
      </div>
    </div>
    <el-dialog
      :visible.sync="exportDialog.visible"
      width="35%"
      :show-close="false"
      :custom-class="'order-export__export-dialog'"
    >
      <div class="order-export__export-dialog-message">
        <span>{{ exportDialog.fileName }}</span>
        <span>{{ exportDialog.estimatedCompletionAt }}</span>
        <el-divider></el-divider>
        <span>{{ exportDialog.tip }}</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="exportDialog.visible = false">
          {{ $t('General.Confirm') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FilterFrame from '@/components/FilterFrame.vue'
import TableLoading from '@/components/TableLoading'
import { apiOrderFood } from '@/api/OrderFood'
import dayjs from 'dayjs'
import { convertKeysToPascalCase, convertKeysToCamelCase } from '@/js/utils/bff'
export default {
  name: 'OrderFoodExportReport',
  components: {
    FilterFrame,
    TableLoading
  },
  data () {
    return {
      filterForm: [], // 篩選表單欄位
      filter: {}, // 篩選參數
      loading: false,
      scrollEnd: false,
      offset: 0,
      maxCount: 10,
      reportDataList: [], // 報表資料列表
      estimatedCompletionTime: 10, // 預計完成時間(分鐘)
      exportDialog: {
        visible: false,
        fileName: '',
        estimatedCompletionAt: '',
        tip: ''
      }
    }
  },
  computed: {
    // 準備中的檔案數量
    inProgressDataCount () {
      return this.reportDataList.filter(item => item.state === 3).length
    }
  },
  async mounted () {
    /**
     * main.js中，設定週一為每週的第一天
     * 1. 理論上應該週日為第一天?
     * 2. 處理 el-date-picker type="week" (單週)，使其能夠顯示正確的「週次」
     */
    const today = new Date()
    const dayOfDate = today.getDay() // 取得今天是星期幾
    let targetWeekDate = dayjs(today).format('YYYY-MM-DD')
    // 如果今天是週日，則取得下一天
    if (dayOfDate === 0) {
      targetWeekDate = dayjs(today).add(1, 'day').format('YYYY-MM-DD')
    }
    // 設定篩選表單欄位
    this.filterForm = [
      {
        label: this.$t('OrderFoodRecord.FilterLabelDate'),
        name: 'date',
        type: 'SingleWeekOrMonth',
        value: {
          date: targetWeekDate,
          radio: 1
        },
        options: [
          {
            label: this.$t('OrderFoodExportReport.SingleWeek'),
            value: 1
          }, {
            label: this.$t('OrderFoodExportReport.SingleMonth'),
            value: 2
          }
        ]
      },
      {
        label: this.$t('OrderFoodRecord.FilterLabelPointType'),
        name: 'priceType',
        type: 'radio',
        value: '',
        options: [
          {
            label: this.$t('OrderFoodExportReport.Normal'),
            value: 1
          }, {
            label: this.$t('OrderFoodExportReport.Cash'),
            value: 2
          }
        ]
      }
    ]
    // 取得報表列表
    this.handleGetReportList()
    // 滾動加載
    window.addEventListener('scroll', this.scrollToLoad, true)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.scrollToLoad, true)
  },
  methods: {
    /**
     * 處理匯出
     * @param {Object} filterData 篩選資料
     */
    async handleExport (filterData) {
      if (filterData) {
        switch (filterData.dateRadio) {
        case 1: // 單週
          this.filter = {
            ...this.getWeekStartAndEnd(filterData.dateDate),
            ...(filterData.priceType !== undefined && { priceType: filterData.priceType })
          }
          break
        case 2: // 單月
          this.filter = {
            startDateTime: dayjs(filterData.dateDate).startOf('month').format('YYYY-MM-DD'),
            endDateTime: dayjs(filterData.dateDate).endOf('month').format('YYYY-MM-DD'),
            ...(filterData.priceType !== undefined && { priceType: filterData.priceType })
          }
          break
        }
      }

      // 同時只能有3個檔案在處理中
      if (this.inProgressDataCount >= 3) {
        const message = `
            ${this.$t('OrderFoodExportReport.InProgressOverLimitAlert')}<br><br>
            ${this.$t('OrderFoodExportReport.RemainFileCount', { count: 3 - this.inProgressDataCount })}
        `
        this.$alert(message, this.$t('General.AlertTitle'), {
          dangerouslyUseHTMLString: true,
          customClass: 'order-export__alert-message',
          type: 'warning'
        })
        return
      }

      let communityName = '社區' // 社區名稱
      try {
        communityName = JSON.parse(localStorage.getItem('loginUserInfo')).CommunityName
      } catch (error) {
        console.log(error)
      }

      const loading = this.$loading({
        lock: true,
        text: this.$t('OrderFoodExportReport.ReserveExportWaiting'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      try {
        const { status } = convertKeysToCamelCase((await apiOrderFood.postTableFoodExportStorage(convertKeysToPascalCase(this.filter))).data)
        if (status === 1) {
          const filterDateRange = `${dayjs(this.filter.startDateTime).format('YYYYMMDD')}-${dayjs(this.filter.endDateTime).format('YYYYMMDD')}`
          const fileName = `${communityName}_${this.$t('OrderFoodExportReport.OrderFoodReport')}_${filterDateRange}`
          const estimatedCompletionAt = dayjs().add(this.estimatedCompletionTime, 'minute').format('YYYY/MM/DD HH:mm')
          this.exportDialog.fileName = `${this.$t('OrderFoodExportReport.Filename')}：${fileName}`
          this.exportDialog.estimatedCompletionAt = `${this.$t('OrderFoodExportReport.FileEstimatedCompletionTime')}：${estimatedCompletionAt}`
          this.exportDialog.tip = `${this.$t('OrderFoodExportReport.ReserveExportTip')}`
          this.exportDialog.visible = true
          // 刷新資料
          this.handleRefreshTable(false)
        }
      } catch (error) {
        console.log(error)
      } finally {
        loading.close()
      }
    },
    /**
     * 取得目標日期當週的第 N 天
     * @param {string} date 目標日期字串 (YYYY-MM-DD)
     * @param {number} dayOfWeek 當週的第N天 (0=週日, 6=週六)
     */
    getWeekDiffDate (date, dayOfWeek) {
      const targetDate = new Date(date)
      const targetDayOfWeek = targetDate.getDay() // 取得目標日期是星期幾
      const diff = dayOfWeek - targetDayOfWeek // 計算與當週的第N天的天數差距
      const weekDiffDate = new Date(targetDate)
      weekDiffDate.setDate(targetDate.getDate() + diff) // 設定日期(加上天數差距)
      return dayjs(weekDiffDate).format('YYYY-MM-DD')
    },
    /**
     * 取得目標日期當週的第一天(週日)與最後一天(週六)
     */
    getWeekStartAndEnd (date) {
      const startDateTime = this.getWeekDiffDate(date, 0) // 取得該週第一天(週日)
      const endDateTime = dayjs(startDateTime).add(6, 'day').format('YYYY-MM-DD') // 取得該週最後一天(週六)
      return {
        startDateTime,
        endDateTime
      }
    },
    async scrollToLoad () {
      this.$handleScrollWithLoading(this.handleGetReportList)
    },
    // 處理取得報表列表
    async handleGetReportList (type) {
      try {
        if (this.scrollEnd || this.loading) return
        this.loading = true

        const params = {
          startDateTime: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
          endDateTime: dayjs().format('YYYY-MM-DD'),
          offset: this.offset,
          maxCount: this.maxCount
        }
        const { data, status } = convertKeysToCamelCase((await apiOrderFood.getTableFoodExportStorageList(convertKeysToPascalCase(params))).data)
        if (status === 1) {
          if (data.tableFoodExportStorages.length < this.maxCount) {
            this.scrollEnd = true
          }
          this.offset += this.maxCount
          await this.$sleep(300)

          const dataList = data.tableFoodExportStorages.map(item => { return {
            ...item,
            displayState: this.getDisplayState(item.state),
            displayPriceType: this.getDisplayPriceType(item.requestContent.priceType),
            updatedAt: dayjs(item.updatedAt).format('YYYY/MM/DD HH:mm'),
            estimatedCompletionAt: dayjs(item.createdAt).add(this.estimatedCompletionTime, 'minute').format('YYYY/MM/DD HH:mm'),
            validDate: dayjs(item.createdAt).add(8, 'day').format('YYYY/MM/DD 00:00')
          } })
          this.reportDataList = [...this.reportDataList, ...dataList]

          if (type === 'refresh') {
            this.$message({
              message: this.$t('OrderFoodExportReport.RefreshTableSuccess'),
              type: 'success'
            })
          }
        } else {
          this.$message({
            message: this.$t('OrderFoodExportReport.GetTableFailed'),
            type: 'error'
          })
        }
      } catch (error) {
        console.log(error)
        this.$message({
          message: this.$t('OrderFoodExportReport.GetTableFailed'),
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    /**
     * 取得狀態顯示文字
     * @param {number} state 狀態
     */
    getDisplayState (state) {
      switch (state) {
      case 1: // 已建立
        return this.$t('OrderFoodExportReport.ReportCreated')
      case 2: // 待處理
        return this.$t('OrderFoodExportReport.ReportPending')
      case 3: // 準備中
        return this.$t('OrderFoodExportReport.ReportInProgress')
      case 4: // 已完成
        return this.$t('OrderFoodExportReport.ReportCompleted')
      case 5: // 失敗
        return this.$t('OrderFoodExportReport.ReportFailed')
      }
    },
    /**
     * 取得篩選條件顯示文字
     * @param {number} state 狀態
     */
    getDisplayPriceType (state) {
      switch (state) {
      case 1:
        return this.$t('OrderFoodExportReport.PointType', { type: this.$t('OrderFoodExportReport.Normal') })
      case 2:
        return this.$t('OrderFoodExportReport.PointType', { type: this.$t('OrderFoodExportReport.Cash') })
      }
    },
    /**
     * 處理刷新表格
     * @param {boolean} isShowMessage 是否顯示提示訊息
     */
    async handleRefreshTable (isShowMessage) {
      this.scrollEnd = false
      this.offset = 0
      this.reportDataList = []
      this.handleGetReportList(isShowMessage)
    },
    /**
     * 處理點擊下載
     * @param {*} row 資料列
     */
    async handleClickDownload (row) {
      let isDownloadSuccess = false
      const loading = this.$loading({
        lock: true,
        text: this.$t('OrderFoodExportReport.DownloadWaiting'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      try {
        const { status, data } = convertKeysToCamelCase((await apiOrderFood.downloadTableFoodExportStorage(row.id)).data)
        if (status === 1) {
          isDownloadSuccess = true
          const link = document.createElement('a')
          link.href = data.urlSigner
          link.download = row.fileName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      } catch (error) {
        console.log(error)
      } finally {
        if (!isDownloadSuccess) {
          this.$message.error(this.$t('OrderFoodExportReport.DownloadFailed'))
        }
        loading.close()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.order-export {
    @include mainLayer();

    &__table-title {
        padding-top: 60px;
        & .title {
            font-size: map-get($fontSize,x-large) !important;
        }
    }
    ::v-deep .el-table {
        @include basicTable;
        &__body a.el-button--default.is-plain{
            color: #333;
        }
    }
    &__completed-content {
        & i {
          font-size: map-get($fontSize,x-large);
        }
    }
    &__completed-tooltip {
        display: flex;
        flex-direction: column;
        font-size: map-get($fontSize,medium);
    }
    &__completed-tooltip-title {
        margin-bottom: 8px;
    }
    ::v-deep &__export-dialog {
      border-radius: 10px;
    }
    ::v-deep &__export-dialog .el-dialog__header {
      display: none;
    }
    ::v-deep &__export-dialog .el-dialog__body {
      padding: 30px 20px 10px 20px;
    }
    &__export-dialog-message {
      display: flex;
      flex-direction: column;
      text-align: left;
      font-size: map-get($fontSize,medium);
      line-height: 1.5;
    }
}
</style>
